import Utils from "@/core/utils/Utils";

class EnUtils {

  /**
   * Formats US Social Security Number
   * @param {number|string} ssn - SSN for formatting (9 digits)
   * @returns {string} Formatted SSN (123-45-6789) or original string if invalid
   */
  static formatSSN(ssn) {
    const string = Utils.string.toString(ssn);
    if (!string || string.length !== 9) return string;

    // Format as 123-45-6789
    return `${string.slice(0, 3)}-${string.slice(3, 5)}-${string.slice(5, 9)}`;
  }
}

export default EnUtils;
